<div class="row mb-3">
    <div class="col-md-6">
         <div class="row">
            <div class="col-md-6"><label>Premium excl IPT:</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="vehicle_insurance_exc_ipt" [value]="displayValue(gross_premium)"  class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>  
        <div class="row mt-3">
            <div class="col-md-6"><label>IPT:</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="vehicle_ipt" [value]="displayValue(ipt)"  class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>   
        <div class="row mt-3">
            <div class="col-md-6"><label>Premium inc IPT:</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="gross" [value]="displayValue(total_prem_inc_ipt)" class="form-control form-control-sm"
                        readonly>
                </div>
            </div>
        </div>
        
        <div class="row mt-3">
            <div class="col-md-6"><label>Peliwica Fee:</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="peliwica_fee" [value]="displayValue(peliwica_fee)" class="form-control form-control-sm"
                        readonly>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6"><label>Total Payable (inc IPT & Fee):</label></div>
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                    </div>
                    <input type="text" name="total_amount" [value]="displayValue(total_amount)" class="form-control form-control-sm"
                        readonly>
                </div>
            </div>
        </div>
    </div>
</div>